module.exports = __webpack_public_path__ + "img/usd.c6478498.svg";